export const isLegacyBilling = (workspace: { billingVersion: string }): boolean => {
  return ['v1', 'v2', 'v3'].includes(workspace.billingVersion)
}
